import styled from "styled-components";

export const StyledDatePickerWrapper = styled.div`
	position: relative;
	width: 100%;
	.react-datepicker-wrapper {
		width: 100%;
	}
	input {
		width: 100%;
	}

	i {
		position: absolute;
		top: 0.8rem;
		right: 0.5rem;
	}
`;
